var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.serienButtonUrl && _vm.serienButtonText
    ? _c(
        "a",
        {
          staticClass: "single__series-button",
          attrs: {
            title: _vm.serienButtonText,
            target: "_blank",
            href: _vm.serienButtonUrl
          }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.serienButtonText))]),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-angle-right" })
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }